"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var expo_modules_core_exports = {};
__export(expo_modules_core_exports, {
  EventEmitter: () => EventEmitter,
  NativeModulesProxy: () => NativeModulesProxy,
  requireNativeModule: () => requireNativeModule,
  requireOptionalNativeModule: () => requireOptionalNativeModule
});
module.exports = __toCommonJS(expo_modules_core_exports);
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _create_class(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var EventEmitter = /* @__PURE__ */ (function() {
  "use strict";
  function EventEmitter2() {
    _class_call_check(this, EventEmitter2);
  }
  _create_class(EventEmitter2, [
    {
      key: "addListener",
      value: function addListener() {
      }
    },
    {
      key: "removeListener",
      value: function removeListener() {
      }
    },
    {
      key: "emit",
      value: function emit() {
      }
    }
  ]);
  return EventEmitter2;
})();
var NativeModulesProxy = {};
var requireNativeModule = function() {
  return {};
};
var requireOptionalNativeModule = function() {
  return null;
};
//# sourceMappingURL=expo-modules-core.js.map
